<template>
  <div class="header-content">
    <div class="title-page">
      Cloud-based Live Production Collaboration
    </div>

    <div class="content-txt">
      Bring your production team and audience together in real-time.TVU Partyline is the industry’s only real-time, ultra-low latency, live production collaboration platform that lets your production team feel like they’re in the same studio – no matter where they are. Forget virtual presence – this is actual presence.
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style scoped>
.title-page{
font-weight: bold;
font-size: 30px;
line-height: 40px;
color: #000000;
text-align: center;
}
.content-txt{
    line-height: 26px;
    padding-top: 14px;
    color: #454545;
    font-weight: 500;
    font-size: 16px;
    width: 70%;
    text-align: center;
    margin: auto;
}
</style>
